import { z } from "zod";

import { useGetQuery, type UseGetQueryOptions } from "../../api";
import { APP_V2_APP_EVENTS } from "../../lib";
import { supportArticleSchema } from "../types";
import { SUPPORT_ARTICLES_URL } from "./constants";

export const supportArticlesResponseSchema = z.object({
  data: z.array(supportArticleSchema),
});
export type SupportArticlesResponse = z.infer<typeof supportArticlesResponseSchema>;

export function useSupportArticles(options: UseGetQueryOptions<SupportArticlesResponse> = {}) {
  return useGetQuery({
    url: SUPPORT_ARTICLES_URL,
    responseSchema: supportArticlesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_BOOKING_REQUESTS_FAILURE,
    },
    ...options,
  });
}
